var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _path13, _path14, _g2, _path15, _path16, _path17, _path18, _path19, _g3, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _g4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrinciples1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.9528 60.0794C51.8086 60.0794 59.7317 49.4332 59.7317 36.3004C59.7317 23.1677 51.8086 12.5215 35.9528 12.5215C20.097 12.5215 12.1738 23.1677 12.1738 36.3004C12.1738 49.4332 20.097 60.0794 35.9528 60.0794Z",
    fill: "url(#paint0_radial_715_19618)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9528 60.0794C51.8086 60.0794 59.7317 49.4332 59.7317 36.3004C59.7317 23.1677 51.8086 12.5215 35.9528 12.5215C20.097 12.5215 12.1738 23.1677 12.1738 36.3004C12.1738 49.4332 20.097 60.0794 35.9528 60.0794Z",
    fill: "url(#paint1_radial_715_19618)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9528 60.0794C51.8086 60.0794 59.7317 49.4332 59.7317 36.3004C59.7317 23.1677 51.8086 12.5215 35.9528 12.5215C20.097 12.5215 12.1738 23.1677 12.1738 36.3004C12.1738 49.4332 20.097 60.0794 35.9528 60.0794Z",
    fill: "url(#paint2_radial_715_19618)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9528 60.0794C51.8086 60.0794 59.7317 49.4332 59.7317 36.3004C59.7317 23.1677 51.8086 12.5215 35.9528 12.5215C20.097 12.5215 12.1738 23.1677 12.1738 36.3004C12.1738 49.4332 20.097 60.0794 35.9528 60.0794Z",
    fill: "url(#paint3_radial_715_19618)",
    fillOpacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9528 60.0794C51.8086 60.0794 59.7317 49.4332 59.7317 36.3004C59.7317 23.1677 51.8086 12.5215 35.9528 12.5215C20.097 12.5215 12.1738 23.1677 12.1738 36.3004C12.1738 49.4332 20.097 60.0794 35.9528 60.0794Z",
    fill: "url(#paint4_radial_715_19618)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9528 60.0794C51.8086 60.0794 59.7317 49.4332 59.7317 36.3004C59.7317 23.1677 51.8086 12.5215 35.9528 12.5215C20.097 12.5215 12.1738 23.1677 12.1738 36.3004C12.1738 49.4332 20.097 60.0794 35.9528 60.0794Z",
    fill: "url(#paint5_radial_715_19618)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9528 60.0794C51.8086 60.0794 59.7317 49.4332 59.7317 36.3004C59.7317 23.1677 51.8086 12.5215 35.9528 12.5215C20.097 12.5215 12.1738 23.1677 12.1738 36.3004C12.1738 49.4332 20.097 60.0794 35.9528 60.0794Z",
    fill: "url(#paint6_radial_715_19618)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9528 60.0794C51.8086 60.0794 59.7317 49.4332 59.7317 36.3004C59.7317 23.1677 51.8086 12.5215 35.9528 12.5215C20.097 12.5215 12.1738 23.1677 12.1738 36.3004C12.1738 49.4332 20.097 60.0794 35.9528 60.0794Z",
    fill: "url(#paint7_radial_715_19618)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1971 29.3467C38.1971 33.3115 41.4112 36.5255 45.3759 36.5255C49.3406 36.5255 52.5547 33.3115 52.5547 29.3467C52.5547 25.382 49.3406 22.168 45.3759 22.168C41.4112 22.168 38.1971 25.382 38.1971 29.3467Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7091 29.3467C33.7091 33.3115 30.4951 36.5255 26.5303 36.5255C22.5656 36.5255 19.3516 33.3115 19.3516 29.3467C19.3516 25.382 22.5656 22.168 26.5303 22.168C30.4951 22.168 33.7091 25.382 33.7091 29.3467Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2755 29.3466C39.2755 32.1452 41.5442 34.4139 44.3428 34.4139C47.1414 34.4139 49.4102 32.1452 49.4102 29.3466C49.4102 26.548 47.1414 24.2793 44.3428 24.2793C41.5442 24.2793 39.2755 26.548 39.2755 29.3466Z",
    fill: "#402931"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6307 29.3466C32.6307 32.1452 30.362 34.4139 27.5634 34.4139C24.7648 34.4139 22.4961 32.1452 22.4961 29.3466C22.4961 26.548 24.7648 24.2793 27.5634 24.2793C30.362 24.2793 32.6307 26.548 32.6307 29.3466Z",
    fill: "#402931"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_715_19618)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9844 41.0605C28.9017 42.248 31.7586 44.623 35.8473 44.623C39.936 44.623 42.934 42.248 43.9219 41.0605",
    stroke: "#4D264E",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9844 41.0605C28.9017 42.248 31.7586 44.623 35.8473 44.623C39.936 44.623 42.934 42.248 43.9219 41.0605",
    stroke: "url(#paint8_radial_715_19618)",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9844 41.0605C28.9017 42.248 31.7586 44.623 35.8473 44.623C39.936 44.623 42.934 42.248 43.9219 41.0605",
    stroke: "url(#paint9_radial_715_19618)",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_715_19618)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9844 40.7793C28.9017 41.9668 31.7586 44.3418 35.8473 44.3418C39.936 44.3418 42.934 41.9668 43.9219 40.7793",
    stroke: "url(#paint10_linear_715_19618)",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25391 26.2168C6.32891 25.5668 5.34766 24.3574 5.02734 23.7324L15.0664 12.9668L28.4414 10.1855L30.0977 16.0293L22.9414 21.998C20.9414 22.848 15.7331 24.9147 13.3789 25.8418C12.4727 26.2376 10.1789 26.8668 8.25391 26.2168Z",
    fill: "url(#paint11_linear_715_19618)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25391 26.2168C6.32891 25.5668 5.34766 24.3574 5.02734 23.7324L15.0664 12.9668L28.4414 10.1855L30.0977 16.0293L22.9414 21.998C20.9414 22.848 15.7331 24.9147 13.3789 25.8418C12.4727 26.2376 10.1789 26.8668 8.25391 26.2168Z",
    fill: "url(#paint12_radial_715_19618)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25391 26.2168C6.32891 25.5668 5.34766 24.3574 5.02734 23.7324L15.0664 12.9668L28.4414 10.1855L30.0977 16.0293L22.9414 21.998C20.9414 22.848 15.7331 24.9147 13.3789 25.8418C12.4727 26.2376 10.1789 26.8668 8.25391 26.2168Z",
    fill: "url(#paint13_radial_715_19618)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25391 26.2168C6.32891 25.5668 5.34766 24.3574 5.02734 23.7324L15.0664 12.9668L28.4414 10.1855L30.0977 16.0293L22.9414 21.998C20.9414 22.848 15.7331 24.9147 13.3789 25.8418C12.4727 26.2376 10.1789 26.8668 8.25391 26.2168Z",
    fill: "url(#paint14_radial_715_19618)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25391 26.2168C6.32891 25.5668 5.34766 24.3574 5.02734 23.7324L15.0664 12.9668L28.4414 10.1855L30.0977 16.0293L22.9414 21.998C20.9414 22.848 15.7331 24.9147 13.3789 25.8418C12.4727 26.2376 10.1789 26.8668 8.25391 26.2168Z",
    fill: "url(#paint15_radial_715_19618)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_715_19618)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5187 22.1082C25.2218 21.2957 28.8468 19.9363 31.9405 18.6707C35.1599 17.5362 35.3404 15.1676 34.7006 13.739C34.032 12.2459 32.1476 11.3816 30.1168 12.2157C28.518 12.8724 27.8937 14.4363 28.0343 16.3426L22.5187 22.1082Z",
    fill: "#FFC744"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5187 22.1082C25.2218 21.2957 28.8468 19.9363 31.9405 18.6707C35.1599 17.5362 35.3404 15.1676 34.7006 13.739C34.032 12.2459 32.1476 11.3816 30.1168 12.2157C28.518 12.8724 27.8937 14.4363 28.0343 16.3426L22.5187 22.1082Z",
    fill: "url(#paint16_linear_715_19618)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5187 22.1082C25.2218 21.2957 28.8468 19.9363 31.9405 18.6707C35.1599 17.5362 35.3404 15.1676 34.7006 13.739C34.032 12.2459 32.1476 11.3816 30.1168 12.2157C28.518 12.8724 27.8937 14.4363 28.0343 16.3426L22.5187 22.1082Z",
    fill: "url(#paint17_radial_715_19618)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8789 17.6396C28.9778 16.3881 33.8477 13.4834 35.8164 12.5146C38.7847 10.8293 38.4641 8.66715 37.582 7.37401C36.6602 6.02244 34.6527 5.50466 32.8012 6.68436C31.3435 7.61311 25.0027 11.3596 23.5195 12.2177L26.8789 17.6396Z",
    fill: "url(#paint18_linear_715_19618)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8789 17.6396C28.9778 16.3881 33.8477 13.4834 35.8164 12.5146C38.7847 10.8293 38.4641 8.66715 37.582 7.37401C36.6602 6.02244 34.6527 5.50466 32.8012 6.68436C31.3435 7.61311 25.0027 11.3596 23.5195 12.2177L26.8789 17.6396Z",
    fill: "url(#paint19_radial_715_19618)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8789 17.6396C28.9778 16.3881 33.8477 13.4834 35.8164 12.5146C38.7847 10.8293 38.4641 8.66715 37.582 7.37401C36.6602 6.02244 34.6527 5.50466 32.8012 6.68436C31.3435 7.61311 25.0027 11.3596 23.5195 12.2177L26.8789 17.6396Z",
    fill: "url(#paint20_linear_715_19618)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8789 17.6396C28.9778 16.3881 33.8477 13.4834 35.8164 12.5146C38.7847 10.8293 38.4641 8.66715 37.582 7.37401C36.6602 6.02244 34.6527 5.50466 32.8012 6.68436C31.3435 7.61311 25.0027 11.3596 23.5195 12.2177L26.8789 17.6396Z",
    fill: "url(#paint21_radial_715_19618)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8789 17.6396C28.9778 16.3881 33.8477 13.4834 35.8164 12.5146C38.7847 10.8293 38.4641 8.66715 37.582 7.37401C36.6602 6.02244 34.6527 5.50466 32.8012 6.68436C31.3435 7.61311 25.0027 11.3596 23.5195 12.2177L26.8789 17.6396Z",
    fill: "url(#paint22_linear_715_19618)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8789 17.6396C28.9778 16.3881 33.8477 13.4834 35.8164 12.5146C38.7847 10.8293 38.4641 8.66715 37.582 7.37401C36.6602 6.02244 34.6527 5.50466 32.8012 6.68436C31.3435 7.61311 25.0027 11.3596 23.5195 12.2177L26.8789 17.6396Z",
    fill: "url(#paint23_radial_715_19618)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6914 15.7169C27.7903 14.4654 32.5652 11.4158 34.0043 10.5428C36.9726 8.85748 36.7535 6.63286 35.8714 5.33972C34.9496 3.98815 32.9808 3.36314 31.1293 4.54284C29.6716 5.47159 23.6589 9.18682 22.1758 10.045L25.6914 15.7169Z",
    fill: "url(#paint24_linear_715_19618)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6914 15.7169C27.7903 14.4654 32.5652 11.4158 34.0043 10.5428C36.9726 8.85748 36.7535 6.63286 35.8714 5.33972C34.9496 3.98815 32.9808 3.36314 31.1293 4.54284C29.6716 5.47159 23.6589 9.18682 22.1758 10.045L25.6914 15.7169Z",
    fill: "url(#paint25_radial_715_19618)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6914 15.7169C27.7903 14.4654 32.5652 11.4158 34.0043 10.5428C36.9726 8.85748 36.7535 6.63286 35.8714 5.33972C34.9496 3.98815 32.9808 3.36314 31.1293 4.54284C29.6716 5.47159 23.6589 9.18682 22.1758 10.045L25.6914 15.7169Z",
    fill: "url(#paint26_linear_715_19618)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6914 15.7169C27.7903 14.4654 32.5652 11.4158 34.0043 10.5428C36.9726 8.85748 36.7535 6.63286 35.8714 5.33972C34.9496 3.98815 32.9808 3.36314 31.1293 4.54284C29.6716 5.47159 23.6589 9.18682 22.1758 10.045L25.6914 15.7169Z",
    fill: "url(#paint27_radial_715_19618)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6914 15.7169C27.7903 14.4654 32.5652 11.4158 34.0043 10.5428C36.9726 8.85748 36.7535 6.63286 35.8714 5.33972C34.9496 3.98815 32.9808 3.36314 31.1293 4.54284C29.6716 5.47159 23.6589 9.18682 22.1758 10.045L25.6914 15.7169Z",
    fill: "url(#paint28_linear_715_19618)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6914 15.7169C27.7903 14.4654 32.5652 11.4158 34.0043 10.5428C36.9726 8.85748 36.7535 6.63286 35.8714 5.33972C34.9496 3.98815 32.9808 3.36314 31.1293 4.54284C29.6716 5.47159 23.6589 9.18682 22.1758 10.045L25.6914 15.7169Z",
    fill: "url(#paint29_radial_715_19618)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4861 15.2251C20.7735 15.6889 21.3794 15.8367 21.8462 15.5544C23.9803 14.2636 26.977 12.4019 28.2387 11.6366C31.207 9.95123 30.9878 7.72661 30.1058 6.43347C29.1839 5.0819 27.2152 4.45689 25.3637 5.63659C23.906 6.56534 18.9714 9.53057 17.4883 10.3887L20.4861 15.2251Z",
    fill: "#FFC52F"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4861 15.2251C20.7735 15.6889 21.3794 15.8367 21.8462 15.5544C23.9803 14.2636 26.977 12.4019 28.2387 11.6366C31.207 9.95123 30.9878 7.72661 30.1058 6.43347C29.1839 5.0819 27.2152 4.45689 25.3637 5.63659C23.906 6.56534 18.9714 9.53057 17.4883 10.3887L20.4861 15.2251Z",
    fill: "url(#paint30_radial_715_19618)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4861 15.2251C20.7735 15.6889 21.3794 15.8367 21.8462 15.5544C23.9803 14.2636 26.977 12.4019 28.2387 11.6366C31.207 9.95123 30.9878 7.72661 30.1058 6.43347C29.1839 5.0819 27.2152 4.45689 25.3637 5.63659C23.906 6.56534 18.9714 9.53057 17.4883 10.3887L20.4861 15.2251Z",
    fill: "url(#paint31_linear_715_19618)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4861 15.2251C20.7735 15.6889 21.3794 15.8367 21.8462 15.5544C23.9803 14.2636 26.977 12.4019 28.2387 11.6366C31.207 9.95123 30.9878 7.72661 30.1058 6.43347C29.1839 5.0819 27.2152 4.45689 25.3637 5.63659C23.906 6.56534 18.9714 9.53057 17.4883 10.3887L20.4861 15.2251Z",
    fill: "url(#paint32_radial_715_19618)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4861 15.2251C20.7735 15.6889 21.3794 15.8367 21.8462 15.5544C23.9803 14.2636 26.977 12.4019 28.2387 11.6366C31.207 9.95123 30.9878 7.72661 30.1058 6.43347C29.1839 5.0819 27.2152 4.45689 25.3637 5.63659C23.906 6.56534 18.9714 9.53057 17.4883 10.3887L20.4861 15.2251Z",
    fill: "url(#paint33_radial_715_19618)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4861 15.2251C20.7735 15.6889 21.3794 15.8367 21.8462 15.5544C23.9803 14.2636 26.977 12.4019 28.2387 11.6366C31.207 9.95123 30.9878 7.72661 30.1058 6.43347C29.1839 5.0819 27.2152 4.45689 25.3637 5.63659C23.906 6.56534 18.9714 9.53057 17.4883 10.3887L20.4861 15.2251Z",
    fill: "url(#paint34_linear_715_19618)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4861 15.2251C20.7735 15.6889 21.3794 15.8367 21.8462 15.5544C23.9803 14.2636 26.977 12.4019 28.2387 11.6366C31.207 9.95123 30.9878 7.72661 30.1058 6.43347C29.1839 5.0819 27.2152 4.45689 25.3637 5.63659C23.906 6.56534 18.9714 9.53057 17.4883 10.3887L20.4861 15.2251Z",
    fill: "url(#paint35_radial_715_19618)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_715_19618)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1286 13.8104C17.8784 16.3885 9.22734 21.4771 5.17526 23.9979C4.2688 22.8104 3.64963 20.168 5.28484 17.7479C8.01919 13.701 11.3161 12.3104 13.2536 11.4354C14.5661 10.7063 17.5574 8.89114 19.2536 7.81042C21.1051 6.63072 23.0739 7.25573 23.9957 8.6073C24.8778 9.90044 25.1438 12.1698 22.1286 13.8104Z",
    fill: "url(#paint36_linear_715_19618)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1286 13.8104C17.8784 16.3885 9.22734 21.4771 5.17526 23.9979C4.2688 22.8104 3.64963 20.168 5.28484 17.7479C8.01919 13.701 11.3161 12.3104 13.2536 11.4354C14.5661 10.7063 17.5574 8.89114 19.2536 7.81042C21.1051 6.63072 23.0739 7.25573 23.9957 8.6073C24.8778 9.90044 25.1438 12.1698 22.1286 13.8104Z",
    fill: "url(#paint37_radial_715_19618)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1286 13.8104C17.8784 16.3885 9.22734 21.4771 5.17526 23.9979C4.2688 22.8104 3.64963 20.168 5.28484 17.7479C8.01919 13.701 11.3161 12.3104 13.2536 11.4354C14.5661 10.7063 17.5574 8.89114 19.2536 7.81042C21.1051 6.63072 23.0739 7.25573 23.9957 8.6073C24.8778 9.90044 25.1438 12.1698 22.1286 13.8104Z",
    fill: "url(#paint38_radial_715_19618)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1286 13.8104C17.8784 16.3885 9.22734 21.4771 5.17526 23.9979C4.2688 22.8104 3.64963 20.168 5.28484 17.7479C8.01919 13.701 11.3161 12.3104 13.2536 11.4354C14.5661 10.7063 17.5574 8.89114 19.2536 7.81042C21.1051 6.63072 23.0739 7.25573 23.9957 8.6073C24.8778 9.90044 25.1438 12.1698 22.1286 13.8104Z",
    fill: "url(#paint39_radial_715_19618)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_715_19618",
    x: 27.1836,
    y: 40.2605,
    width: 17.7891,
    height: 5.7626,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.25,
    dy: 0.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.32549 0 0 0 0 0.203922 0 0 0 0 0.14902 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_19618"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_715_19618",
    x: 27.2344,
    y: 40.0293,
    width: 17.4375,
    height: 5.0625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_715_19618"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_715_19618",
    x: 22.5195,
    y: 11.5904,
    width: 12.6766,
    height: 10.5178,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.1,
    dy: -0.3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.960784 0 0 0 0 0.635294 0 0 0 0 0.203922 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_19618"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.2,
    dy: -0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.811765 0 0 0 0 0.541176 0 0 0 0 0.258824 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_715_19618",
    result: "effect2_innerShadow_715_19618"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_715_19618",
    x: 4.26758,
    y: 7.1875,
    width: 20.5703,
    height: 16.9603,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.25,
    dy: 0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.780392 0 0 0 0 0.654902 0 0 0 0 0.345098 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_19618"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_715_19618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.0917 24.4119) rotate(132.839) scale(63.7044)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474827,
    stopColor: "#FFB02E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F70A8D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_715_19618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.0917 24.4119) rotate(131.878) scale(66.1595)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474827,
    stopColor: "#FFB02E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F70A8D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_715_19618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.9547 30.3571) rotate(101.31) scale(30.3148 38.8274)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.787821,
    stopColor: "#F59639",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972509,
    stopColor: "#FF7DCE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_715_19618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.3519 32.9051) rotate(135) scale(69.6646)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.314853,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_715_19618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.9547 38.001) rotate(77.692) scale(47.8113)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.507903,
    stopColor: "#7D6133",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#715B32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_715_19618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.804 37.1517) rotate(55.7131) scale(22.6148 16.3923)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB847",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_715_19618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.5985 39.6996) rotate(9.86581) scale(19.8275)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA64B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.900412,
    stopColor: "#FFAE46",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_715_19618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.5026 34.6037) rotate(43.9708) scale(100.309)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.185425,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_715_19618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.9821 40.0605) rotate(138.731) scale(2.03725 1.83688)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F4E50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4E50",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_715_19618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.0758 39.7793) rotate(49.7429) scale(5.07762 1.77441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57434C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57434C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_715_19618",
    x1: 30.2321,
    y1: 41.373,
    x2: 36.3258,
    y2: 44.3418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56404E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56404E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_715_19618",
    x1: 17.5625,
    y1: 17.8105,
    x2: 8.09766,
    y2: 23.1855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1A530"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_715_19618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.22266 27.248) rotate(-40.1355) scale(8.33854 6.64295)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE9654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE9654",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_715_19618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.1281 15.6666) rotate(130.301) scale(13.2493 20.3632)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.769412,
    stopColor: "#F3A731",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1A64E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_715_19618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.0568 14.8746) rotate(12.1715) scale(6.65109 3.54673)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB639",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_715_19618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.9727 25.873) rotate(-42.6102) scale(11.1247 6.3546)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A23E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7A23E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_715_19618",
    x1: 24.5343,
    y1: 19.8113,
    x2: 28.5343,
    y2: 20.8113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.315862,
    stopColor: "#FFB032"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC946",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_715_19618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.5968 13.5613) rotate(122.005) scale(5.30661 5.06829)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE667"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC744",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_715_19618",
    x1: 36.7551,
    y1: 7.70967,
    x2: 23.8727,
    y2: 16.4341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0A42F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_715_19618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.3164 8.56151) rotate(153.783) scale(4.598 4.92525)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEBA32",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_715_19618",
    x1: 31.6963,
    y1: 7.02713,
    x2: 34.3182,
    y2: 9.54016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7A357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.850699,
    stopColor: "#FFC42D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_715_19618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.5195 17.3013) rotate(-48.4015) scale(9.04954 11.696)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.302151,
    stopColor: "#FDA04C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDA04C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_715_19618",
    x1: 33.624,
    y1: 14.2867,
    x2: 32.9311,
    y2: 13.0911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F19B3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F19B3A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_715_19618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.7539 10.624) rotate(150.354) scale(11.1825 5.82609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.618587,
    stopColor: "#FFA24E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922119,
    stopColor: "#FFB639"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_715_19618",
    x1: 35.0494,
    y1: 5.629,
    x2: 22.1821,
    y2: 13.9723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0A42F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_715_19618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.0352 5.43561) rotate(150.866) scale(4.36472 4.7868)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEBA32",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_715_19618",
    x1: 30.1289,
    y1: 4.93561,
    x2: 32.7852,
    y2: 7.37311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7A357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.850699,
    stopColor: "#FFC42D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_715_19618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.0664 15.3731) rotate(-49.6355) scale(9.02303 11.591)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.302151,
    stopColor: "#FDA04C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDA04C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_715_19618",
    x1: 32.0039,
    y1: 12.3106,
    x2: 31.2852,
    y2: 11.1231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F19B3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F19B3A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_715_19618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.0664 7.62311) rotate(148.147) scale(12.4351 7.47457)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.638597,
    stopColor: "#FFA24E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922119,
    stopColor: "#FFB639"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_715_19618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.7778 14.9384) rotate(-11.3296) scale(9.08488 9.11668)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.141832,
    stopColor: "#FC9F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_715_19618",
    x1: 24.9414,
    y1: 14.0919,
    x2: 24.2852,
    y2: 12.9981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.189076,
    stopColor: "#F09A35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F09A35",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_715_19618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.4868 8.27742) rotate(110.501) scale(7.82588 11.371)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.842155,
    stopColor: "#FFB639",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB639"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_715_19618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.4102 10.5371) rotate(-13.7853) scale(1.73755 2.40983)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.334056,
    stopColor: "#FFA80F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA80F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_715_19618",
    x1: 22.7227,
    y1: 7.06061,
    x2: 24.7539,
    y2: 9.24811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0480768,
    stopColor: "#C6A253"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBD38",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_715_19618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.6914 7.09186) rotate(150.945) scale(4.1826 5.03248)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC033",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_715_19618",
    x1: 22.5969,
    y1: 9.62291,
    x2: 4.26758,
    y2: 21.4979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0A42F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_715_19618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.5969 9.12291) rotate(150.573) scale(5.59715 5.68928)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBB32",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_715_19618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.1594 16.1229) rotate(-119.055) scale(2.57391 10.3199)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA24F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA24F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_715_19618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.3938 15.0448) rotate(-120.801) scale(0.945926 6.925)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.184951,
    stopColor: "#F19B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F19B3D",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinciples1);
export default __webpack_public_path__ + "static/media/principles1.e908520bfbdf1bde2578938e2595d2bf.svg";
export { ForwardRef as ReactComponent };